<template>
  <div class="card-add">
    <el-form style="min-width:305px;">
      <el-form-item label="图片 ：" class="uploadImg" label-width="100px">
        <upload
          :url="form.cardUrl"
          @successUpload="handleSuccessUpload"
          prompt="上传封面图片：大小不超过2M，支持Jpeg、Jpg、Png格式，建议上传750*382尺寸。"
        />
      </el-form-item>
      <el-form-item label="展示内容 ：" label-width="100px">
        <el-checkbox v-model="form.showCigar">雪茄</el-checkbox>
        <el-checkbox v-model="form.showBoutique">配件</el-checkbox>
        <el-checkbox v-model="form.showPersonalMade">服务</el-checkbox>
      </el-form-item>
      <el-form-item v-if="!$route.query.view">
        <div class="submit">
          <el-button type="primary" :loading="loading" @click="handleSave">保存</el-button>
          <el-button @click="handleCancel">取消</el-button>
        </div>
      </el-form-item>
    </el-form>
  </div>
</template>
<script>
import { addUserCard, updateUserCard, getUserCard } from '@/api/prefer';
import Upload from '@/components/Upload/index.vue';

export default {
  data() {
    return {
      loading: false,
      checkList: [],
      form: {
        cardUrl: '',
        showCigar: false,
        showBoutique: false,
        showPersonalMade: false,
      },
    };
  },
  components: {
    Upload,
  },
  mounted() {
    const { id } = this.$route.query;
    if (id) {
      this.getUserCard();
    }
  },
  methods: {
    // 获取会员卡信息
    getUserCard() {
      getUserCard().then((res) => {
        if (res.success && res.data) {
          const { cardState, createTime, ...rest } = res.data;
          this.form = rest;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    addUserCard() {
      this.loading = true;
      addUserCard(this.form).then((res) => {
        if (res.success) {
          this.loading = false;
          this.$message.success('添加成功');
          this.$router.push({
            name: 'Membercard',
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    updateUserCard() {
      this.loading = true;
      updateUserCard(this.form).then((res) => {
        if (res.success) {
          this.loading = false;
          this.$message.success('编辑成功');
          this.$router.push({
            name: 'PreferConfigList',
          });
        } else {
          this.$message.error(res.message);
        }
      });
    },
    handleSuccessUpload(url) {
      this.form.cardUrl = url;
    },
    handleSave() {
      const { id } = this.$route.query;
      const { showCigar, showBoutique, showPersonalMade } = this.form;
      if (this.form.cardUrl === '') {
        this.$message.warning('请上传图片');
      } else if (!showCigar && !showBoutique && !showPersonalMade) {
        this.$message.warning('请选择展示内容');
      } else if (id) {
        this.updateUserCard();
      } else {
        this.addUserCard();
      }
    },
    handleCancel() {
      this.$router.push({
        name: 'PreferConfigList',
      });
    },
  },
};
</script>

<style lang="stylus" scoped>
@import '~assets/css/mixins'
.card-add
  flex-row()
  justify-content center
  >>>.el-form-item__content
    margin-left 0 !important
  .uploadImg
    flex-row()
  .show-content
    margin 30px 0
    span
      margin-right 30px
  .submit
    flex-row()
    justify-content center
    margin-top 150px
</style>
